"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CreateNewFolderStyled = require("./CreateNewFolder-styled.js");
var _actions = _interopRequireDefault(require("../../utils/actions"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CreateNewFolder = function CreateNewFolder(_ref) {
  var createFolderActive = _ref.createFolderActive,
    userSession = _ref.userSession,
    getUserFolders = _ref.getUserFolders,
    setCreateFolderActive = _ref.setCreateFolderActive,
    queryResults = _ref.queryResults;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    createFolderInputValue = _useState2[0],
    setCreateFolderInputValue = _useState2[1];
  var handleConfirm = function handleConfirm() {
    _actions.default.createFolder({
      folderName: createFolderInputValue,
      userSession: userSession,
      getUserFolders: getUserFolders,
      queryResults: queryResults
    });
    setCreateFolderInputValue("");
  };
  var handleCancel = (0, _react.useCallback)(function () {
    setCreateFolderInputValue("");
    setCreateFolderActive(false);
  }, [setCreateFolderActive]);
  (0, _react.useEffect)(function () {
    var cancelBtn = document.getElementsByClassName("calcite-inline-editable__cancel-editing-button")[0];
    cancelBtn && cancelBtn.addEventListener("click", handleCancel);
    return function () {
      cancelBtn && cancelBtn.removeEventListener("click", handleCancel);
    };
  }, [handleCancel]);
  return /*#__PURE__*/_react.default.createElement(_CreateNewFolderStyled.StyledCreateNewFolder, null, createFolderActive ? /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteInlineEditable, {
    controls: true,
    editingEnabled: true,
    style: {
      width: "40rem"
    },
    afterConfirm: handleConfirm
  }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteInput, {
    icon: "folder-plus",
    placeholder: "Enter folder name",
    name: "create-folder",
    label: "Folder Name:",
    value: createFolderInputValue,
    onCalciteInputInput: function onCalciteInputInput(e) {
      setCreateFolderInputValue && setCreateFolderInputValue(e.target.value);
    }
  })) : /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteLink, {
    iconStart: "folder-plus",
    onClick: function onClick() {
      return setCreateFolderActive(true);
    },
    style: {
      fontSize: "0.85rem"
    }
  }, "Create new folder"));
};
var _default = CreateNewFolder;
exports.default = _default;